import React from 'react'
import StencilBox from '../stencils/StencilBox'
import { Link } from 'react-scroll'

function TrainingProgramTwoStencil() {
    return (
        <div>
            <div className="edu-course-area eduvibe-home-five-course course-three-wrapper edu-section-gap">
                <div className="container eduvibe-animated-shape">
                    <div className="row">
                        <div className="col-lg-6">
                            <StencilBox
                                className="pre-title stencil-sm-devic mb--10"
                                width="50%"
                                height="26px"
                                backgroundColor="#F5F5F5"
                            />
                            <StencilBox
                                className="pre-title stencil-sm-devic"
                                width="90%"
                                height="56px"
                                backgroundColor="#F5F5F5"
                            />
                        </div>
                        <div className="col-lg-6">
                            <div className="load-more-btn text-end">
                                <Link className="edu-btn-stencil">
                                    <StencilBox
                                        className="sf-blog-btn-stencil"
                                        width="223px"
                                        height="60px"
                                        backgroundColor="#F5F5F5"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 mt--25">
                        {[0, 1, 2, 3]?.map((i) => (
                            <div className={`col-12 col-lg-6`}>
                                <div class={`edu-blog-widget-2 widget-latest-post`}>
                                    <div class="inner">
                                        <div class="content bg-post latest-post-list">
                                            <div class="flex-column flex-sm-row align-items-start latest-post">
                                                <div class="thumbnail">
                                                    <div className="d-block training-programs-image">
                                                        <StencilBox
                                                            width="100px"
                                                            height="100px"
                                                            backgroundColor="#F5F5F5"
                                                        />
                                                    </div>
                                                </div>
                                                <div className='content-left text-start'>
                                                    <div class="post-content">
                                                        <h5 className="placeholder-glow mb-0">
                                                            <span className="placeholder w-100"></span>
                                                        </h5>
                                                        <ul className="list-unstyled placeholder-glow d-flex gap-3 align-items-center flex-wrap mb-0">
                                                            <li>
                                                                <span className="placeholder order-detail h-50"></span>
                                                            </li>
                                                            <li>
                                                                <span className="placeholder order-detail h-50"></span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="w-100 d-flex align-items-center justify-content-start">
                                                        <div className="price w-50 h-100 placeholder placeholder-glow"></div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default TrainingProgramTwoStencil
